import Controls from './controls';
export default Controls;


// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/index.js